import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Spanish DNI generator following Single Responsibility Principle
 */
export class EsGenerator extends BaseGenerator {
  generate() {
    // Generate 8 random digits
    const digits = this.randomDigits(8);
    
    // Calculate check letter
    const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
    const checkLetter = letters[parseInt(digits) % 23];
    
    return digits + checkLetter;
  }
}